import { shopAuthHeader, ApiConfigs } from '../_helpers';

export const shopService = {
    login,
    register,
    verify,
    products,
    swipe,
    cart,
    removeItem,
    getProfileInfo,
    getVoucher
};


function login(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.login}`, requestOptions).then(handleResponse);
}


function register(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.register}`, requestOptions).then(handleResponse);
}


function verify(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.verify}`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('shop_user', JSON.stringify(user.user));
                localStorage.setItem('shop_token', JSON.stringify(user.token));
            }
            return user;
        });
}


function products() {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'}
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.products}`, requestOptions).then(handleResponse);
}


function swipe(id, action) {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'}
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.swipe.replace(':id', id).replace(':action', action)}`, requestOptions).then(handleResponse);
}


function cart() {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'}
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.cart}`, requestOptions).then(handleResponse);
}


function getProfileInfo() {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'}
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.getProfileInfo}`, requestOptions).then(handleResponse);
}


function getVoucher(data) {
    const requestOptions = {
        method: 'POST',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.getVoucher}`, requestOptions).then(handleResponse);
}


function removeItem(id) {
    const requestOptions = {
        method: 'GET',
        headers: {...shopAuthHeader(), 'Content-Type': 'application/json'}
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.shop.remove_item.replace(":id", id)}`, requestOptions).then(handleResponse);
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) { localStorage.removeItem('user');
                // auto logout if 401 response returned from api
                /*location.reload(true);*/
                window.location.href = '/shop/login';
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}